import React from 'react';
import styled from 'styled-components';

import LabeledContent from '../../LabeledContent';

import { DestinationInfoProps } from './types';

const LABELED_CONTENT_LABEL_CLASS_NAME = 'labeled-content__label';

const StyledLabeledContent = styled(LabeledContent)`
  & .${LABELED_CONTENT_LABEL_CLASS_NAME} {
    margin-bottom: 0.583333333rem;
    font-size: 1rem;
    color: #8d9199;
  }
`;

const StyledInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 0.666666667rem;
`;

const DestinationInfo = ({
  className,
  children,
  label,
}: DestinationInfoProps) => (
  <StyledLabeledContent
    className={className}
    label={label}
    labelClassName={LABELED_CONTENT_LABEL_CLASS_NAME}
  >
    <StyledInnerContainer>
      {children}
    </StyledInnerContainer>
  </StyledLabeledContent>
);

export default DestinationInfo;
